export const AGENCY_SERVICE_KEYS = {
  dmv: [
    'SelectAgency_Service_VehicleRegistrationRenewal',
    'SelectAgency_Service_MailingAddressChange',
  ],
  dps: [
    'SelectAgency_Service_AddressChange',
    'SelectAgency_Service_Renewal',
    'SelectAgency_Service_Replacement',
    'SelectAgency_Service_Surrender',
    'SelectAgency_Service_Upgrade',
    'SelectAgency_Service_EmergencyContactUpdates',
  ],
  tpwd: [
    'SelectAgency_Service_BoatRegistrationRenewal',
    'SelectAgency_Service_ReplacementIdCards',
    'SelectAgency_Service_ReplacementDecals',
  ],
  tdlr: [
    'SelectAgency_Service_MassageTherapyInstructorRenewal',
    'SelectAgency_Service_MassageTherapyRenewal',
  ],
};
